import React from "react";
import cbd from "./cbd.json";
import "./cbd.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah.jsx";
import simprug from "../../../asset/cbd/simprug/simprug.js";
import ores from "../../../asset/cbd/ores/ores.js";
import kunvil from "../../../asset/cbd/kunvil/kunvil.js";
const imageMap = {
  simprug,
  ores,
  kunvil,

  // Add other image arrays here if you have more sets
};

const Cbd = () => {
  return (
    <div className="cbd">
      <div className="container-cbd">
        <div className="header">
          <div className="judul-cbd">
            <div className="pink"></div>
            <span>CBD Pantai Indah Kapuk</span>
          </div>
        </div>
        <div className="cardhome-container">
          {cbd.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Cbd;
